export default __webpack_public_path__ + "static/media/clio-rs-large.604df915.jpg";